export const DATA_KEY = 'treeview';
export const EVENT_KEY = `.${DATA_KEY}`;

export const EVENT_EXPANDED = `expanded${EVENT_KEY}`;
export const EVENT_COLLAPSED = `collapsed${EVENT_KEY}`;

export const CLASS_NAME_MENU_OPEN = 'menu-open';
export const SELECTOR_NAV_ITEM = '.nav-item';
export const SELECTOR_NAV_LINK = '.nav-link';
export const SELECTOR_TREEVIEW_MENU = '.nav-treeview';
export const SELECTOR_DATA_TOGGLE = '[data-toggle="treeview"]';
